<script>
    export let src;
</script>

<div class="flex justify-center items-center py-1">
    <img class="h-20" src="{src}" alt="logo-game" />
</div>